export const CONTENTFUL_IMAGES_DOMAIN = 'images.ctfassets.net'

export const CONTENTFUL_COINBASE_IMAGES_CDN = 'ctf-images-01.coinbasecdn.net'
